import React from 'react';
import './Schema.css'
import assetsimg44 from './ASSETS/asset-1.png'
import { Button } from 'react-bootstrap';
const CreateScheme=()=>{
    return(
        <section className="sc2-input-field">
        <div className="sc2-input-con1 sc2fl" >
        <br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br>
           <br></br>
          <div className="imgss">
                <div>
                    <label >Scheme Name</label>
                </div>
              <input />
          </div>
          <div  className="imgss ">
            <div>
                <label >Address</label>
            </div>
            <input/>
          </div>
          <br></br><br></br>
          <div  className="imgss">
            <div>
                <label >City</label>
            </div>
            <input/>
          </div>
          <div  className="imgss ">
                <div> 
                    <label >State</label>
                </div>
                <input/>
            </div>
          <br></br><br></br>
          <div  className="imgss">
            <div>
                <label >Country</label>
            </div>
             <input/>
            </div>
          <div  className="imgss">
                <div>
                    <label >GST Number</label>
                </div>
                <input/>
            </div>
        </div>

        <div className="sc2-input-con2 sc2fl" >
        <br></br> <br></br>
      <div className="imgss eclipseim imgmid">
      <img src={assetsimg44} className="sc2-icon assim "/>
       
        </div> <br></br> <br></br><br></br><br></br>
        <div>
        <label>Payment Method:</label>
        <div style={{width:200, justifyContent:'space-between', display:'flex'}}>
            <span>
                <input type="radio" name="payment_method" aria-label="payment_method"/>
                <br/>
                Prepaid 
            </span>
            <span>
                <input type="radio" name="payment_method" aria-label="payment_method"/>
                <br/>
                Post Paid 
            </span>
            <span>
                <input type="radio" name="payment_method" aria-label="payment_method"/>
                <br/>
                Wallet
            </span>
        </div>
    </div>
      <div  className="imgss imgmid">
            <div>
                <label >Operation Contact person</label>
            </div>
        <input/>
        <div>
            <label>Email-ID</label>
        </div>
        <input/>
      </div>
      <div  className="imgss imgmid">
       <div>
            <label >Mobile Number</label>
        </div>
        <input/>
        <div>
            <label >Sales Team</label>
        </div>
        <input/>
        </div>
      <br></br><br></br><br/>
      <br/><br/>
      <button  className="imgss yelobtn">Create Scheme</button>
      <br></br><br></br>
      
</div>
      <div className="sc3-input-con3 sc2fl">
        <br/>
        <br/>
        <br/>
        <br/>
        <br/>
        <br/>
        <br/>
        <br/>
        <br/>
        <br/>
        <br/>
        <br/>
        <br/>
        <br/>
        <br/>
        <div>
            <div>
            <label >CRM/Account Manager</label>
            </div>
            <input/>
        </div>
        <div>
            <div>
            <label >Payment Method</label>
            </div>
            <input/>
        </div>
        <div>
            <div>
            <label >Credit Period(if applicable)</label>
            </div>
            <input/>
        </div>
        <div>
            <div>
            <label >Agreement/PO Copy</label>
            </div>
            <input/>
        </div>
        <div>
            <div>
            <label >Extension/Renewal agreement/PO Copy</label>
            </div>
            <input/>
        </div>
        </div>


      </section>
    )
}
export default CreateScheme;